'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _effects = require('redux-saga/effects');

var _common = require('./common');

var _formSubmitSaga = require('./form-submit-saga');

var _formSubmitSaga2 = _interopRequireDefault(_formSubmitSaga);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var factory = function factory(SubmissionError) {
  return {
    onSubmitActions: _common.onSubmitActions,
    formSubmitSaga: (0, _formSubmitSaga2.default)(SubmissionError),

    addFormSubmitSagaTo: function addFormSubmitSagaTo(root) {
      if (!root) {
        return (0, _formSubmitSaga2.default)(SubmissionError);
      }
      return _regenerator2.default.mark(function formSubmitSagaComposed() {
        return _regenerator2.default.wrap(function formSubmitSagaComposed$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return [(0, _effects.spawn)(root), (0, _effects.spawn)((0, _formSubmitSaga2.default)(SubmissionError))];

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, formSubmitSagaComposed, this);
      });
    }
  };
};

exports.default = factory;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form-submit-saga/lib/create.js
// module id = 1898
// module chunks = 1